export const myData = [
  {
    id: "001",
    thumbnail:
      "https://gambolthemes.net/html-items/cursus_main_demo/images/courses/img-2.jpg",
    title: "Course Title Here",
    purchases: 70,
    comments: 1150,
    views: 1850,
  },
  {
    id: "002",
    thumbnail:
      "https://gambolthemes.net/html-items/cursus_main_demo/images/courses/img-3.jpg",
    title: "Course Title Here",
    purchases: 86,
    comments: 2150,
    views: 6850,
  },
  {
    id: "003",
    thumbnail:
      "https://gambolthemes.net/html-items/cursus_main_demo/images/courses/img-2.jpg",
    title: "Course Title Here",
    purchases: 90,
    comments: 1500,
    views: 5000,
  },
];
